import React from 'react';
import enhance from './enhance';
import {
  ComposedChart,
  Area,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import styles from './styles.module.scss';

export const ComparisonChart = ({
  selectedTemplatesByPriceBand,
  toggleSelectedLine,
  toggleSuggestedArea,
  showSelected,
  showSuggested,
  selectedFilterStyle,
  suggestedFilterStyle,
  suggestedTemplatesLabel,
  selectedTemplatesLabel,
  currentSelectedQuantity,
  suggestedTemplateQuantity,
  data,
  resetFilters,
  clearFiltersLabel,
  quantityAbbrvLabel,
  selectedColor,
}) => {
  return (
    <div className={styles.comparisonChart}>
      <span className={styles.yLabel}>{quantityAbbrvLabel}</span>
      <ResponsiveContainer>
        <ComposedChart data={data} margin={{ top: 20, bottom: 20 }}>
          <XAxis
            dataKey="priceBandLabel"
            tickLine={false}
            padding={{ left: -75 }}
            tick={{ fontSize: 12, dy: 10 }}
            allowDecimals={false}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 10 }}
            allowDecimals={false}
          />
          <Tooltip />
          {showSuggested && (
            <Area
              type="monotone"
              dataKey={suggestedTemplatesLabel}
              fill="#d3d3e0"
              stroke="#d3d3e0"
              isAnimationActive={false}
              dot={{ strokeWidth: 2, stroke: 'white', fill: '#d3d3e0', r: 6 }}
            />
          )}
          {showSelected && (
            <Line
              isAnimationActive={false}
              type="monotone"
              dataKey={selectedTemplatesLabel}
              stroke={selectedColor}
              dot={{
                strokeWidth: 2,
                stroke: 'white',
                fill: selectedColor,
                r: 6,
              }}
            />
          )}
        </ComposedChart>
      </ResponsiveContainer>
      <div className={styles.filterContainer}>
        <div className={styles.filterSection}>
          <button onClick={toggleSelectedLine} className={selectedFilterStyle}>
            <svg width="12" height="12">
              <rect
                width="12"
                height="12"
                style={{
                  fill: selectedColor,
                  strokeWidth: 3,
                  stroke: selectedColor,
                }}
              />
            </svg>
            {selectedTemplatesLabel} ({currentSelectedQuantity})
          </button>

          <button
            onClick={toggleSuggestedArea}
            className={suggestedFilterStyle}
          >
            <svg width="12" height="12">
              <rect
                width="12"
                height="12"
                style={{ fill: '#d3d3e0', strokeWidth: 3, stroke: '#d3d3e0' }}
              />
            </svg>
            {suggestedTemplatesLabel} ({suggestedTemplateQuantity})
          </button>
        </div>

        <span className={styles.clearFilters} onClick={resetFilters}>
          {clearFiltersLabel}
        </span>
      </div>
    </div>
  );
};

export default enhance(ComparisonChart);
